import {StoreType} from '../../../types/sharedTypes';

export const isLoadingSelector = (state: StoreType) => {
  return state.generalReducer.loading;
}
export const currentRouteSelector = (state: StoreType) => {
  return state.generalReducer.currentRoute;
}
